import { cmsToKmh, cmsToMph } from '@/local/server-data/utils/conversion'

export function getMaxSpeedValue(valueInCms: number, useMetric: boolean) {
  const val = useMetric ? Math.round(cmsToKmh(valueInCms)) : Math.round(cmsToMph(valueInCms))
  return Math.round(val)
}
